<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-card shadow="never" class="settings-container">
      <el-form label-position="top">
        <el-row type="flex" justify="space-between" align="middle">
          <el-col :span="21">
            <el-form-item :label="$t('settings.form.fastRun')">
              <el-select
                v-model="settings.fastRunPreset"
                :placeholder="$t('common.components.select.placeholder')"
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in fastRunOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="text-align:right;">
            <el-form-item style="margin-top:45px;">
              <el-button
                type="primary"
                @click="onFastRunSubmit($t('settings.form.fastRun'))"
                >{{ $t("common.buttons.save") }}</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" justify="space-between" align="middle">
          <el-col :span="18">
            <el-form-item
              label="Максимальное количество записей, возвращаемое при запросе на поиск"
            >
              <el-input-number
                v-model.lazy="settings.queryLimit"
                :precision="0"
                :controls="false"
                :min="limitRecords.minRet"
                :max="limitRecords.maxRet"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="text-align:right;">
            <el-form-item style="margin-top:45px;">
              <el-button type="primary" @click="onLimitReset"
                >Сбросить</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="3" style="text-align:right;">
            <el-form-item style="margin-top:45px;">
              <el-button
                type="primary"
                @click="onFastRunSubmit('Максимальное количество записей')"
                >{{ $t("common.buttons.save") }}</el-button
              >
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { fastRunOptions } from "@/mixins/fastRunOptions";

export default {
  name: "settings",
  mixins: [fastRunOptions],
  data() {
    return {
      settings: {
        fastRunPreset: null,
        queryLimit: 0
      }
    };
  },
  async created() {
    document.title = this.$t("settings.title");
    await this.ping();

    // загрузка настроек из LS, проверка на существование ключей, настройка значений по умолчанию
    const savedSettings = this.$localStorage.get("wb-settings");
    if (savedSettings) {
      const parseSettings = JSON.parse(savedSettings);
      this.settings.fastRunPreset = parseSettings.fastRunPreset || "";
      // this.settings.queryLimit = this.checkQueryLimit(parseSettings.queryLimit);
    } else {
      this.settings.fastRunPreset = this.fastRunOptions[0].value;
      // this.settings.queryLimit = this.limitRecords.defRet;
    }
  },
  computed: {
    ...mapGetters(["loading", "initPage", "limitRecords"])
  },
  methods: {
    ...mapActions(["ping"]),
    // checkQueryLimit(limit) {
    //   if (isNaN(+limit)) return this.limitRecords.defRet;
    //   const truncLimit = Math.trunc(limit);
    //   return truncLimit >= this.limitRecords.minRet &&
    //     truncLimit <= this.limitRecords.maxRet
    //     ? limit
    //     : this.limitRecords.defRet;
    // },
    onFastRunSubmit(title) {
      this.$localStorage.set("wb-settings", JSON.stringify(this.settings));
      this.$notify({
        title, //: this.$t("settings.notify.title"),
        message: this.$t("settings.notify.message"),
        type: "success",
        duration: 3000
      });
      // лимит запросов поместить в стейт !!!
    },
    onLimitReset() {
      this.settings.queryLimit = this.limitRecords.defRet;
    }
  }
};

// function isInteger(n) {
//    return ((typeof n==='number')&&(n%1===0));
// }

// function isFloat(n) {
//    return ((typeof n==='number')&&(n%1!==0));
// }

// function isNumber(n) {
//    return (typeof n==='number');
// }
</script>

<style scoped>
.settings-container {
  height: calc(100vh - 93px);
}
</style>

<style lang="scss">
.el-input-number .el-input__inner {
  text-align: left;
}
</style>
